import React, { Component } from 'react';
import DateTimePicker from 'react-datetime';

import {
  Glyphicon,
  // FormGroup,
  // ControlLabel,
  InputGroup,
  FormControl
} from 'react-bootstrap';
// import { formatDate } from '../utils/format';
import moment from 'moment';

class Datepicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      format: 'DD/MM/YYYY',
      mode: 'date',
      minDate: moment().subtract(1, 'day')
    };
  }

  _handleFocus = e => {
    e.target.nextSibling.click();
  };

  handleChange = momentDate => {
    try {
      const dateString = momentDate.format(this.state.format);
      this.props.onChange(dateString);
    } catch (e) {
      if (__DEV__) {
        console.error(e);
      }
    }
  };

  isValidDate = current => {
    return current.isAfter(this.state.minDate);
  };

  renderInput = (finalInputProps, openCalendar) => {
    return (
      <InputGroup>
        <FormControl readOnly type="text" {...finalInputProps} />
        <InputGroup.Addon>
          <Glyphicon glyph="calendar" onClick={openCalendar} />
        </InputGroup.Addon>
      </InputGroup>
    );
  };

  render() {
    const { date: dateString } = this.props;
    const { format } = this.state;

    const value = dateString
      ? moment(dateString, format)
      : moment()
          .add(2, 'month')
          .startOf('month');

    return (
      <DateTimePicker
        timeFormat={false} // disable timepicker
        closeOnSelect
        dateFormat={format}
        isValidDate={this.isValidDate}
        onChange={this.handleChange}
        value={value}
        renderInput={this.renderInput}
        inputProps={{
          placeholder: format,
          onFocus: this._handleFocus
        }}
      />
    );
  }
}

export default Datepicker;
